<template>
  <div>
    <div class="title" @click="goBack">
      <van-icon name="arrow-left" />
      <h2>用户协议</h2>
    </div>
    <div class="content">
      <div class="company-name">
        微信公众号用户服务协议
      </div>
      <p class="company-desc">
        重要提示<br>
        欢迎您注册并使用本微信公众号平台服务！为保障您的权益，请在注册前仔细阅读本协议的全部条款（特别是加粗条款）。如您不同意本协议内容，请立即停止使用相关服务。您的注册、登录、使用等行为即视为已阅读并完全理解本协议的所有内容，同意接受本协议及平台规则的约束。
      </p>
      <p class="company-desc">
        第一条 定义与解释<br>
        1.1中科金联综合服务平台公众号：指由我司提供技术支持，以下简称“本平台”。<br>
        1.2用户：指注册、登录、使用本平台服务的自然人、法人或其他组织，包括但不限于订阅用户、服务使用方等。<br>
        1.3内容：包括文字、图片、音频、视频、链接、代码及其他任何形式的数字信息。<br>
      </p>
      <p class="company-desc">
        第二条 账户注册与管理<br>
        2.1注册资格<br>
        用户须为具备完全民事行为能力的自然人，或依法设立并有效存续的法人/组织。未成年人使用服务需经监护人同意。<br>
        2.2实名认证<br>
        用户需通过手机号验证、身份证绑定或企业资质认证等方式完成实名登记。如提供虚假信息，平台有权终止服务并追究法律责任。<br>
        2.3账户安全<br>
        用户需妥善保管账号及密码，不得转让、出借或共享。因用户过失导致的账户被盗、数据泄露等损失由用户自行承担。<br>
      </p>
      <p class="company-desc">
        第三条 服务内容与使用规则<br>
        3.1基础服务<br>
        平台向用户提供信息发布、粉丝管理、数据分析、支付接口等基础功能，具体以实际开放功能为准。<br>
        3.2禁止行为<br>
        用户承诺不得从事以下行为：<br>
        违反宪法或法律法规；<br>
        危害国家安全、泄露国家秘密；<br>
        传播暴力、色情、赌博等违法信息；<br>
        侵犯他人知识产权、名誉权、隐私权；<br>
        利用自动脚本、爬虫等干扰平台正常运行；<br>
        其他违反公序良俗或平台规则的行为。<br>
      </p>
      <p class="company-desc">
        3.3内容审核<br>
        平台有权对用户发布的内容进行审核，并采取删除、屏蔽、限制传播等措施，且无需事先通知。<br>
      </p>
      <p class="company-desc">
        第四条 用户权利与义务<br>
        4.1用户权利<br>
        依法使用平台提供的各项服务；<br>
        对个人信息处理活动提出询问、更正或删除请求；<br>
        对违规内容进行投诉举报。<br>
        4.2用户义务<br>
        遵守中国法律法规及平台管理规范；<br>
        确保发布内容的真实性、合法性；<br>
        承担因使用服务产生的网络数据流量费用。<br>
      </p>
      <p class="company-desc">
        第五条 平台权利与义务<br>
        5.1服务变更<br>
        平台有权根据业务需要调整服务内容、中断或终止部分功能，并提前通过公告等形式通知用户。<br>
        5.2数据使用<br>
        平台可对用户行为数据（如阅读量、点击率）进行统计分析，用于优化服务或商业合作，但不得泄露个人隐私信息。<br>
        5.3争议处理<br>
        用户与其他主体发生纠纷时，平台可提供必要信息协助，但无义务参与纠纷解决。<br>
      </p>
      <p class="company-desc">
        第六条 个人信息保护<br>
        6.1收集范围<br>
        根据服务需要，平台可能收集以下信息：<br>
        身份信息：姓名、单位信息；<br>
        联系方式：手机号、电子邮箱；<br>
        设备信息：IP地址、浏览器类型、操作日志。<br>
        6.2使用目的<br>
        个人信息将用于账户管理、安全防范、客服响应及法律法规要求的其他用途。<br>
        6.3共享与披露<br>
        未经用户同意，平台不得向第三方提供个人信息，但以下情形除外：<br>
        为完成支付、物流等必要合作；<br>
        应司法机关或政府主管部门要求；<br>
        用户自行公开的信息。<br>
      </p>
      <p class="company-desc">
        第七条 知识产权<br>
        7.1平台权利<br>
        本平台所有界面设计、数据库、源代码等知识产权均归属平台或其授权方所有。<br>
        7.2侵权处理<br>
        收到知识产权侵权通知后，平台将依照《信息网络传播权保护条例》采取必要措施。<br>
      </p>
      <p class="company-desc">
        第八条 免责声明<br>
        8.1不可抗力<br>
        因战争、地震、病毒攻击等不可抗力导致的服务中断，平台不承担赔偿责任。<br>
        8.2第三方服务<br>
        用户通过本平台跳转至第三方网站或服务时，需自行判断风险并承担相应责任。<br>
        8.3内容责任<br>
        用户发布的内容仅代表其个人观点，平台不对其真实性、合法性负责。<br>
      </p>
      <p class="company-desc">
        第九条 违约责任<br>
        9.1 用户违反本协议约定，平台有权采取以下措施：<br>
        删除违规内容；<br>
        限制或终止账户权限；<br>
        追究法律责任并要求赔偿损失。<br>
        9.2 平台因过错造成用户损失，赔偿上限为当年度用户实际支付的服务费用总额。<br>
      </p>
      <p class="company-desc">
        第十条 协议变更与终止<br>
        10.1 平台有权修订本协议条款，修订后将通过站内公告、邮件等方式通知。如用户继续使用服务，即视为接受修订后的协议。<br>
        10.2 用户可随时申请注销账户，账户注销后仍须承担注销前的行为责任。<br>
      </p>
      <p class="company-desc">
        第十一条 法律适用与争议解决<br>
        11.1 本协议适用中华人民共和国法律（不含冲突法）。<br>
        11.2 因本协议产生的争议，双方应协商解决；协商不成的，提交本平台所在地有管辖权的人民法院诉讼解决。<br>
      </p>
      <p class="company-desc">
        第十二条 其他条款<br>
        12.1 本协议条款部分无效不影响其他条款的效力。<br>
        12.2 本协议自用户勾选同意时生效，长期有效。<br>
        12.3 联系方式：<br>
        联系电话：400-180-2128<br>
        公司地址：北京市丰台区五圈南路30号<br>
        最后更新日期：2025年3月26日<br>
      </p>
      <p class="company-desc">
        请再次确认您已完整阅读并理解本协议全部内容。如有疑问，请联系客服咨询。<br>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "introduce",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.title {
  padding: 20px 20px 10px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px 20px 60px;
}

.company-name {
  text-align: center;
  font-size: 18px;
  line-height: 48px;
}

.company-desc {
  line-height: 30px;
  text-indent: 2em;
  letter-spacing: 2px;
}
</style>
